module.exports = __webpack_public_path__ + "media/images/ashton-header-small-914b075308bf9cf9872d28ce43ff26f3.png";